module.exports = "../fonts/SFUIText-Bold.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/SFUIText-Bold.eot
// module id = 572
// module chunks = 0